import { EMAIL } from "./content";

// ───────────────────────────────────────────────────────────────
// Hello — for whoever opens devtools. The mark again, drawn in
// characters with the same light, and a short note.
// ───────────────────────────────────────────────────────────────

const RAMP = " .:-=+*#%@";

function sphere(cols = 36, rows = 16) {
  const l = Math.hypot(-0.7, 0.5, 0.6);
  const [lx, ly, lz] = [-0.7 / l, 0.5 / l, 0.6 / l];
  const lines = [];
  for (let j = 0; j < rows; j++) {
    let line = "";
    for (let i = 0; i < cols; i++) {
      const x = ((i + 0.5) / cols) * 2 - 1;
      const y = 1 - ((j + 0.5) / rows) * 2;
      const r2 = x * x + y * y;
      if (r2 > 1) {
        line += " ";
        continue;
      }
      const z = Math.sqrt(1 - r2);
      const v = 0.05 + 0.95 * Math.max(0, x * lx + y * ly + z * lz);
      line += RAMP[Math.min(RAMP.length - 1, Math.floor(v * RAMP.length))];
    }
    lines.push(line.trimEnd());
  }
  return lines.join("\n");
}

export default function hello() {
  console.log(`%c${sphere()}`, "font-family: monospace; line-height: 1.15; color: #888");
  console.log(
    `%cHi. You opened the console.%c\nThe mark is a 4×4 Bayer dither, 28 cells across. Say hello: ${EMAIL}`,
    "font-weight: bold",
    "color: #888"
  );
}
